<template>
  <div>
    <div class="layout-header" ref="searchBox">
      <div class="infor-layout-header">
        <span class="title">站外还车扣费</span>
      </div>
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
        size="small">
        <el-form-item label="品牌编号：">
          <el-select style="width: 160px" v-model="form.brandId" placeholder="">
            <el-option :label="item.brandName" :value="item.brandId" v-for="item in companyDataWithAll" :key="'company'+item.brandId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户编号：">
          <el-input class="w120px" v-model="form.userNo" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="违规次数：">
          <el-select style="width: 160px" v-model="form.counts" placeholder="" >
            <el-option :label="item.label" :value="item.value" v-for="item in options" :key="'fee'+item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="扣费时间：">
          <el-date-picker
            v-model="date"
            type="monthrange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
          <el-button @click="onExport">导出</el-button>
        </el-form-item>
        <div style="margin-right:20px;float: right;">
          <span style="font-size: 20px;color: red">扣费总金额：{{sumAmount}} 元</span>
        </div>
      </el-form>
    </div>
    <div style="height: 165px"></div>
    <div class="pagination-bg-white layout-header">
      <w-table
        width="100%"
        v-loading.body="tableLoading"
        :height="tableViewHeight"
        :data-list="tabledata"
        :pageNo="form.pageNum"
        :pageSize="form.pageSize"
        :total="total"
        @pageNoChange="pageNoChange"
        @handleSizeChange="handleSizeChange"
        :columns="columns">
        <template slot-scope="props" slot="cell">
          <span v-if="props.column.label === '品牌名称'">{{ props.row.brandName }}</span>
          <span v-else-if="props.column.label === '用户编号'">{{ props.row.userNo }}</span>
          <span v-else-if="props.column.label === '订单编号'">
            <span>{{ props.row.orderNo }}</span>
          </span>
          <span v-else-if="props.column.label === '车辆编号'">{{ props.row.bikeId }}</span>
          <span v-else-if="props.column.label === '扣费时间'">
            <span>{{props.row.feeTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
          </span>
          <span v-else-if="props.column.label === '扣费金额'">{{ props.row.feeAmount }}</span>
          <span v-else-if="props.column.label === '违规次数'">
          <span v-if="props.row.counts>1" @click="onShowCounts(props.row.userNo)"
                class="cursor"
                style="color: #409eff">
            {{ props.row.counts }}
          </span>
          <span v-else>{{ props.row.counts }}</span>
          </span>
          <span v-else>{{ props.row[props.column.property]}}</span>
        </template>
      </w-table>
    </div>
    <w-dialog
      ref="w-dialog"
      title="选择导出字段"
      width="35%"
      sureBtnText="导出"
      @handleClose="handleCloseExport"
      @handleCloseRight="handleCloseExport"
      @onSure="onSureExport">
      <template v-slot:content>
        <div class="dialog-content">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
          >全选
          </el-checkbox>
          <div style="margin: 15px 0"></div>
          <el-checkbox-group
            v-model="checkedFields"
            @change="handleCheckedFieldsChange"
          >
            <el-checkbox
              style="margin-bottom: 10px"
              v-for="item in exportOptions"
              :label="item.key"
              :key="item.key">
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </w-dialog>
    <w-dialog
      ref="w-fee-dialog"
      title="用户扣费违规详情"
      :isShowFooter="false"
      @handleCloseRight="handleCloseFee"
      width="80%">
      <template v-slot:content>
        <w-table
          width="100%"
          v-loading.body="feeTableLoading"
          :data-list="feeTableData"
          :pageNo="form.feePageNum"
          :pageSize="form.feePageSize"
          :total="feeTotal"
          :columns="feeColumns">
          <template slot-scope="props" slot="cell">
            <span v-if="props.column.label === '品牌名称'">{{ props.row.brandName }}</span>
            <span v-else-if="props.column.label === '用户编号'">{{ props.row.userNo }}</span>
            <span v-else-if="props.column.label === '订单编号'">
            <span>{{ props.row.orderNo }}</span>
            </span>
            <span v-else-if="props.column.label === '车辆编号'">{{ props.row.bikeId }}</span>
            <span v-else-if="props.column.label === '扣费时间'">
            <span>{{props.row.feeTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
            </span>
            <span v-else-if="props.column.label === '扣费金额'">{{ props.row.feeAmount }}</span>
            <span v-else>{{ props.row[props.column.property]}}</span>
          </template>
        </w-table>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import Api from '@/api'
import { mapGetters } from 'vuex'
import WTable from '@/components/Table/index.vue'
import WDialog from '@/components/Model/index.vue'
import { compare, downloadExcel, getFilterParams } from '@/utils/tools'
export default {
  name: 'bikeOutSideFee',
  components: {
    WTable,
    WDialog
  },
  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 20,
        brandId: '',
        feePageNum: 1,
        feePageSize: 20
      },
      total: 0,
      date: [],
      tableViewHeight: '',
      columns: [
        {
          prop: 'brandName',
          label: '品牌名称'
        },
        {
          prop: 'userNo',
          label: '用户编号'
        },
        {
          prop: 'orderNo',
          label: '订单编号'
        },
        {
          prop: 'bikeId',
          label: '车辆编号'
        },
        {
          prop: 'feeTime',
          label: '扣费时间'
        },
        {
          prop: 'feeAmount',
          label: '扣费金额'
        },
        {
          prop: 'counts',
          label: '违规次数'
        }
      ],
      tableLoading: true,
      tabledata: [],
      checkedFields: [],
      isIndeterminate: true,
      checkAll: false,
      exportOptions: [
        {
          key: 1,
          label: '品牌名称'
        },
        {
          key: 2,
          label: '用户编号'
        },
        {
          key: 3,
          label: '订单编号'
        },
        {
          key: 4,
          label: '车辆编码'
        },
        {
          key: 5,
          label: '车辆MAC地址'
        },
        {
          key: 6,
          label: '租车站点编号'
        },
        {
          key: 7,
          label: '租车站点经度'
        },
        {
          key: 8,
          label: '租车站点纬度'
        },
        {
          key: 9,
          label: '还车经度'
        },
        {
          key: 10,
          label: '还车纬度'
        },
        {
          key: 11,
          label: '还车时间'
        },
        {
          key: 12,
          label: '扣费时间'
        },
        {
          key: 13,
          label: '扣费金额'
        },
        {
          key: 14,
          label: '费用退还时间'
        },
        {
          key: 15,
          label: '退费金额'
        },
        {
          key: 16,
          label: '创建时间'
        },
        {
          key: 17,
          label: '违规次数'
        }
      ],
      options: [
        {
          value: '1',
          label: '1次'
        },
        {
          value: '2',
          label: '2次'
        },
        {
          value: '3',
          label: '3次'
        },
        {
          value: '4',
          label: '4次'
        },
        {
          value: '5',
          label: '5次'
        },
        {
          value: 'more',
          label: '更多'
        }
      ],
      sumAmount: 0, // 扣费总金额
      feeColumns: [
        {
          prop: 'brandName',
          label: '品牌名称'
        },
        {
          prop: 'userNo',
          label: '用户编号'
        },
        {
          prop: 'orderNo',
          label: '订单编号'
        },
        {
          prop: 'bikeId',
          label: '车辆编号'
        },
        {
          prop: 'feeTime',
          label: '扣费时间'
        },
        {
          prop: 'feeAmount',
          label: '扣费金额'
        }
      ],
      feeTableLoading: true,
      feeTableData: [],
      feeTotal: 0
    }
  },
  computed: {
    ...mapGetters(['user', 'selfAreaId', 'userLevel', 'tableDataBrands']),
    companyDataWithAll() {
      const companyDataWithAll = JSON.parse(JSON.stringify(this.tableDataBrands))
      companyDataWithAll.unshift({
        brandName: '全部',
        brandId: ''
      })
      return companyDataWithAll
    }
  },
  created() {
    this.date = [new Date(), new Date()]
    this.onSearch()
  },
  methods: {
    onSearch() {
      this.getData()
    },
    onReset() {
      this.date = [new Date(), new Date()]
      this.form.brandId = ''
      this.form.counts = ''
      this.form.userNo = ''
      this.getData()
    },
    getData() {
      this.tableLoading = true
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.form.pageNum,
        pageSize: this.form.pageSize,
        userNo: this.form.userNo,
        counts: this.form.counts
      }
      if (this.form.brandId) {
        params.brandId = this.form.brandId
      }
      if (this.date) {
        // String.fromCharCode(32) 空格字符的ASCII码(32)
        const startTime = this.dayjs(this.date[0]).startOf('month').format('YYYY-MM-DD')
        const endTime = this.dayjs(this.date[1]).endOf('month').format('YYYY-MM-DD')
        params.startTime = startTime + String.fromCharCode(32) + '00:00:00'
        params.endTime = endTime + String.fromCharCode(32) + '23:59:59'
      }
      Api.getBikeOutSideFeeList(params).then((res) => {
        this.tableLoading = false
        if (res.code === 200 && res.data.lists) {
          this.tabledata = res.data.lists
          this.total = res.data.total
          this.sumAmount = res.data.totalAmount
        } else {
          this.$message.warning(res.message)
        }
        this.calcView()
      })
    },
    pageNoChange(page) {
      this.form.pageNum = page
      this.getData()
    },
    onShowCounts(userNo) {
      this.feeTableLoading = true
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.form.feePageSize,
        pageSize: this.form.feePageSize,
        userNo: userNo
      }
      if (this.form.brandId) {
        params.brandId = this.form.brandId
      }
      if (this.date) {
        // String.fromCharCode(32) 空格字符的ASCII码(32)
        const startTime = this.dayjs(this.date[0]).startOf('month').format('YYYY-MM-DD')
        const endTime = this.dayjs(this.date[1]).endOf('month').format('YYYY-MM-DD')
        params.startTime = startTime + String.fromCharCode(32) + '00:00:00'
        params.endTime = endTime + String.fromCharCode(32) + '23:59:59'
      }
      Api.getFeeUserDetails(params).then((res) => {
        this.feeTableLoading = false
        this.$refs['w-fee-dialog'].onShowDialog()
        if (res.code === 200 && res.data.lists) {
          this.feeTableData = res.data.lists
          this.feeTotal = res.data.total
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleCloseFee() {
      this.$refs['w-fee-dialog'].onCloseDialog()
    },
    handleSizeChange(size) {
      this.form.pageSize = size
      this.getData()
    },
    onExport() {
      this.$refs['w-dialog'].onShowDialog()
    },
    onSureExport() {
      const vm = this
      vm.tableLoading = true
      if (vm.checkedFields.length < 4) {
        vm.$message.warning('请至少选择4项！')
      }
      let data = {}
      data = {
        selfAreaId: this.selfAreaId,
        userNo: this.form.userNo,
        brandId: this.form.brandId,
        counts: this.form.counts
      }
      const startTime = this.dayjs(this.date[0]).startOf('month').format('YYYY-MM-DD')
      const endTime = this.dayjs(this.date[1]).endOf('month').format('YYYY-MM-DD')
      data.startTime = startTime + String.fromCharCode(32) + '00:00:00'
      data.endTime = endTime + String.fromCharCode(32) + '23:59:59'
      data.export =
        vm.checkedFields && vm.checkedFields.length
          ? vm.checkedFields.sort(compare).join(',') : ''
      data = getFilterParams(data)
      console.log(data, 'data')
      console.log(this.id)
      Api.exportBikeOutSideFeeList(this.selfAreaId, data).then((res) => {
        if (res.code === 200) {
          console.log(res)
          downloadExcel(res.data)
          vm.tableLoading = false
          vm.handleCloseExport()
        } else {
          vm.$message.warning(res.message)
        }
        vm.tableLoading = false
      })
    },
    handleCheckAllChange(val) {
      this.checkedFields = val ? this.exportOptions.map((it) => it.key) : []
      this.isIndeterminate = false
    },
    handleCheckedFieldsChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.exportOptions.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.exportOptions.length
    },
    handleCloseExport() {
      this.checkedFields = []
      this.isIndeterminate = true
      this.checkAll = false
      this.$refs['w-dialog'].onCloseDialog()
    },
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - 56 - H - 96 - 56
      })
    }
  }
}
</script>

<style lang="less">
.layout-header {
  margin: 16px;
  width: calc(98% - 20px);
}

.demo-form-inline{
  margin-top: 24px;
}
</style>
